import { useMutation, useQueryClient } from '@tanstack/react-query';
import { disableSSO } from '../../api/sso';

export function useDisableSSSOMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      organizationId,
      connectionId,
    }: {
      organizationId: number;
      connectionId: number;
    }) => disableSSO(organizationId, connectionId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['sso-status', variables.organizationId],
      });
    },
  });
}
